<form [formGroup]="dateForm" class="grid-container">
  <mat-form-field id="datepicker" mat-input-height-large-label>
    <mat-label>{{ '+INSTALLATIONS.INSTALLATION.DATE_AND_TIME.DATE' | translate }} </mat-label>
    <input
      date-at-current-date
      formControlName="date"
      matInput
      readonly
      [matDatepicker]="dateDatepicker"
      gtm="onSet"
      gtmAction="Date and time value"
      gtmCategory="edit-device-time"
      fieldTextContentTooltip
    />
    <mat-datepicker-toggle
      *ngIf="setTimeEnabled"
      matIconSuffix
      [for]="dateDatepicker"
    ></mat-datepicker-toggle>
    <mat-datepicker #dateDatepicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field id="timeinput" mat-input-height-large-label>
    <mat-label>{{ '+INSTALLATIONS.INSTALLATION.DATE_AND_TIME.TIME' | translate }} </mat-label>
    <input
      date-at-current-time
      formControlName="time"
      matInput
      [readonly]="!setTimeEnabled"
      mask="Hh:m0"
      [dropSpecialCharacters]="false"
      gtm="onSet"
      gtmAction="Date and time value"
      gtmCategory="edit-device-time"
      [value]="dateForm.getRawValue().time"
      fieldTextContentTooltip
    />
  </mat-form-field>
  <div *ngIf="setTimeEnabled" class="date-button-wrapper">
    <button
      gtm="onClick"
      gtmAction="Save date and time value"
      gtmCategory="edit-device-time"
      (click)="saveDateAndTime()"
      mat-raised-button
      color="primary"
    >
      {{ '+INSTALLATIONS.INSTALLATION.DATE_AND_TIME.SEND_VALUES_TO_THE_DEVICE' | translate }}
    </button>
  </div>
</form>
